import { createDecorator } from 'vue-class-component';

export const FunctionalComponent = createDecorator((options) => {
    (options as any).functional = true;
});
